<p *ngIf="fullWheelLabel">
  {{ fullWheelLabel.getFormattedLabel() }}
</p>
